import { render, staticRenderFns } from "./Modanisa.vue?vue&type=template&id=7dc511b2&scoped=true"
import script from "./Modanisa.vue?vue&type=script&lang=js"
export * from "./Modanisa.vue?vue&type=script&lang=js"
import style0 from "./Modanisa.vue?vue&type=style&index=0&id=7dc511b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc511b2",
  null
  
)

export default component.exports